import { VChip } from 'vuetify/lib/components/VChip';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._l((_vm.categorias),function(item,index){return [(index < 3)?_c(VChip,{key:index,staticClass:"mr-1",attrs:{"small":"","outlined":""}},[_vm._v("\n      "+_vm._s(item.descricao)+"\n    ")]):_vm._e()]}),_c(VChip,{directives:[{name:"show",rawName:"v-show",value:(_vm.categorias.length > 3),expression:"categorias.length > 3"}],attrs:{"small":"","outlined":""}},[_vm._v("\n    + "+_vm._s(_vm.categorias.length - 3)+"\n  ")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }